import React, { useEffect, useRef } from "react";
import { LoginCallback } from "@okta/okta-react";
import { useOktaAuth } from "@okta/okta-react";
import session from "../session";

const BASE_PATH = import.meta.env.VITE_BASE_PATH ?? "";

export const CustomLoginCallback: React.FC = () => {
  const { authState } = useOktaAuth();
  const redirecting = useRef(false);

  // Ensure session is started when authentication is successful
  useEffect(() => {
    if (authState?.isAuthenticated) {
      session.start();
    }
  }, [authState]);

  // Handle PKCE codeVerifier errors caused by page reload on the callback URL
  // or React StrictMode double-invoking effects. Restart the auth flow.
  const handleError = (error: Error) => {
    if (error.message.includes("codeVerifier") && !redirecting.current) {
      redirecting.current = true;
      window.location.replace(window.location.origin + BASE_PATH + "/");
    }
  };

  return (
    <LoginCallback
      errorComponent={({ error }) => {
        handleError(error);
        return null;
      }}
    />
  );
};
